import { Text } from '@heathmont/moon-core';
import Translate from '~/client/shared/i18n/Translate';
import QuestionText from '../styles/QuestionText';

const HowToUseText: FC = () => (
  <Text as="p">
    <QuestionText as="span" size={14} isBold>
      <Translate id="casino.how_to_use_rtp?" />
    </QuestionText>
    <Text as="span" size={14} isBold={false}>
      <Translate id="casino.rtp_live_onboarding_tooltip" />
    </Text>
  </Text>
);

export default HowToUseText;
